import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-34c81daf")

_pushScopeId("data-v-34c81daf")
const _hoisted_1 = {
  key: 0,
  class: "px-16 py-10 f-sm f-medium bg-white",
  style: {"position":"sticky","top":"0","left":"0","right":"0"}
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "f-medium f-nm df-middle" }
const _hoisted_4 = {
  key: 0,
  class: "close ml-4"
}
const _hoisted_5 = { class: "px-6 f-nm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_SymbolLink = _resolveComponent("SymbolLink")
  const _component_RealTimeQuote = _resolveComponent("RealTimeQuote")
  const _component_AsyncNullableList = _resolveComponent("AsyncNullableList")
  const _component_Holder = _resolveComponent("Holder")
  const _component_Scroller = _resolveComponent("Scroller")
  const _component_GuideTarget = _resolveComponent("GuideTarget")

  return (_openBlock(), _createBlock(_component_GuideTarget, {
    name: "marketList",
    class: "df-col",
    style: {"height":"100%"}
  }, {
    default: _withId(() => [
      (_ctx.tabs.d.length)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs.d, (tab, id) => {
              return (_openBlock(), _createBlock("a", {
                key: id,
                class: ["toggle__line-btn mr-4 p-4", { active: _ctx.tabs.sel === id }],
                onClick: ($event: any) => (_ctx.change(id))
              }, [
                (_ctx.isAll)
                  ? (_openBlock(), _createBlock(_component_t, {
                      key: 0,
                      path: tab.name
                    }, null, 8, ["path"]))
                  : (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(tab.name), 1))
              ], 10, ["onClick"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_Scroller, {
        class: "flex-1 h100",
        onBottomTouched: _ctx.bottom
      }, {
        default: _withId(() => [
          _createVNode(_component_Holder, {
            content: _ctx.list,
            "holder-class": 'px-16'
          }, {
            default: _withId(() => [
              _createVNode(_component_AsyncNullableList, {
                "list-data": _ctx.list,
                "pull-refresh": "",
                "list-class": "table-list",
                onRefresh: _ctx.load
              }, {
                default: _withId(({ item }) => [
                  _createVNode(_component_RealTimeQuote, { symbol: item }, {
                    default: _withId(({ price, mp, isRise }) => [
                      _createVNode(_component_SymbolLink, {
                        code: item.code,
                        class: "row f-md df-between anchor px-16 py-12"
                      }, {
                        default: _withId(() => [
                          _createVNode("p", _hoisted_3, [
                            _createTextVNode(_toDisplayString(item.code) + " ", 1),
                            (item?.isClosed === _ctx.MarketState.CLOSED)
                              ? (_openBlock(), _createBlock("span", _hoisted_4, " Closed "))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", null, [
                            _createVNode("span", {
                              class: ["f-medium badge-market success", { danger: !isRise }]
                            }, [
                              _createVNode("span", _hoisted_5, _toDisplayString(price), 1)
                            ], 2),
                            _createVNode("p", {
                              class: ["c-success mt-4 t-right ", { 'c-danger': !isRise }]
                            }, _toDisplayString(mp), 3)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["code"])
                    ]),
                    _: 2
                  }, 1032, ["symbol"])
                ]),
                _: 1
              }, 8, ["list-data", "onRefresh"])
            ]),
            _: 1
          }, 8, ["content"])
        ]),
        _: 1
      }, 8, ["onBottomTouched"])
    ]),
    _: 1
  }))
})